<script setup>
import { watch } from "vue";
import { Toaster } from "vue-sonner";
import { useStore } from "vuex";

import ErrorBoundary from "@/components/shared/error-boundary/ErrorBoundary";
import SnsIsland from "@/components/ui/SnsIsland.vue";
import { useTheme } from "@/composables/useTheme";

const store = useStore();
const { isDarkTheme, useThemeLifecycle } = useTheme();

useThemeLifecycle();

watch(
  () => store.getters.isAuth,
  (isAuth) => {
    if (isAuth) {
      store.dispatch("verifyToken");
    }
  },
  { immediate: true },
);
</script>

<template>
  <div>
    <ErrorBoundary>
      <router-view />
    </ErrorBoundary>

    <SnsIsland position="bottom-right" />

    <Toaster rich-colors :theme="isDarkTheme ? 'dark' : 'light'" />
  </div>
</template>
